import React from 'react';

import { Icon } from '@chakra-ui/react';

export const JITIcon = props => (
  <Icon viewBox="0 0 32 32" color="inherit" h="full" w="full" {...props}>
    <path d="M30,15.5a0.5,0.5,0,0,0-.5.5A13.52,13.52,0,1,1,28,9.86l-1.44-.38a0.51,0.51,0,0,0-.61.35,0.5,0.5,0,0,0,.35.61l2.56,0.68,0.13,0a0.5,0.5,0,0,0,.48-0.37l0.67-2.49a0.5,0.5,0,0,0-.35-0.61,0.51,0.51,0,0,0-.61.35L28.85,9.29A14.49,14.49,0,1,0,30.5,16,0.5,0.5,0,0,0,30,15.5Z" />
    <ellipse cx="4.06" cy="16" rx="0.94" ry="0.93" />
    <ellipse cx="16" cy="4.07" rx="0.94" ry="0.93" />
    <ellipse cx="27.94" cy="16" rx="0.94" ry="0.93" />
    <ellipse cx="16" cy="27.93" rx="0.94" ry="0.93" />
    <path d="M10.64,21.27a0.5,0.5,0,0,0,.71,0l5-4.92A0.5,0.5,0,0,0,16.5,16l0-8.66a0.5,0.5,0,0,0-.5-0.5h0a0.5,0.5,0,0,0-.5.5l0,8.45-4.85,4.77A0.5,0.5,0,0,0,10.64,21.27Z" />
  </Icon>
);
